import {
  CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC,
  FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC,
  HANDLE_EMAIL_LIST_CHANGE,
  HANDLE_SELECT_ALL_EMAILS,
} from './constants'

const getSpamAllowList = () => ({
  type: FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE,
})
export const getSpamAllowListSuccess = (data) => ({
  type: FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.SUCCESS,
  payload: { data },
})
export const getSpamAllowListError = (error) => ({
  type: FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.ERROR,
  error,
})
const getSpamAllowListCancel = () => ({
  type: FETCH_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL,
})

const createSpamAllowList = (params) => ({
  type: CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.INITIATE,
  payload: { params },
})
export const createSpamAllowListSuccess = (data) => ({
  type: CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.SUCCESS,
  payload: { data },
})
export const createSpamAllowListError = (error) => ({
  type: CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.ERROR,
  error,
})
const createSpamAllowListCancel = () => ({
  type: CREATE_SPAM_ALLOWLIST_SENDERS_ASYNC.CANCEL,
})

const handleEmailListChange = (email) => ({
  type: HANDLE_EMAIL_LIST_CHANGE,
  payload: { email },
})

const handleSelectAllEmails = (emails) => ({
  type: HANDLE_SELECT_ALL_EMAILS,
  payload: { emails },
})

export default {
  // to props
  getSpamAllowList,
  getSpamAllowListCancel,
  handleEmailListChange,
  createSpamAllowList,
  createSpamAllowListCancel,
  handleSelectAllEmails,
}
